// StatBox.jsx
import React, { useEffect, useState } from "react";
import AnimatedNumbers from "react-animated-numbers";

export const StatBox = ({ title, target, shouldAnimate }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (!shouldAnimate) return;

    const startTime = Date.now();
    const duration = 1000;
    const intervalTime = 50;

    const interval = setInterval(() => {
      const now = Date.now();
      const elapsed = now - startTime;

      if (elapsed < duration) {
        const randomValue = Math.floor(Math.random() * (target + 50));
        setDisplayValue(randomValue);
      } else {
        clearInterval(interval);
        setDisplayValue(target);
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [shouldAnimate, target]);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 24,
        textAlign: "center",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        minWidth: 200,
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: "#555",
          marginBottom: 8,
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 48, fontWeight: "bold", color: "#222" }}>
        <AnimatedNumbers
          animateToNumber={displayValue}
          transitions={(index) => ({
            type: "spring",
            duration: 0.4,
          })}
        />
        +
      </div>
    </div>
  );
};
